import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  /**
   * Check if the application is in maintenance mode
   * Returns true if maintenance mode is enabled, false otherwise
   */
  checkMaintenanceStatus(): boolean {
    const maintenanceValue = environment.maintenance;

    if (maintenanceValue === undefined || maintenanceValue === null) {
      return false;
    }

    if (typeof maintenanceValue === 'boolean') {
      return maintenanceValue;
    }

    if (typeof maintenanceValue === 'string') {
      return (maintenanceValue as string).trim().toLowerCase() === 'true';
    }

    return false;
  }
}
